<template>
    <div class="hotel-list">
        <div class="hotel-list-container">
            <div class="d-flex justify-space-between">
                <v-chip
                    class="mb-3"
                    color="info"
                    label
                    outlined
                >
                    <v-icon left>
                        mdi-information-outline
                    </v-icon>
                    <span>
                    Os números dos contadores dos filtros de status se referém à quantidade de tarifas
                    que se encontram nas determinadas situações.
                </span>
                </v-chip>
            </div>
            <list-hotel/>
        </div>
    </div>
</template>

<script>
import ListHotel from "../../components/Hotel/ListHotel.vue";

export default {
    name: "HotelList",
    components: {
        ListHotel,
    },
}
</script>

<style lang="scss" scoped>
.hotel-list {
    background-color: #f0f0f0;
    height: 100%;
    &-container {
        padding: 20px;
        width: 100%;
    }
}
</style>
